module.exports = __webpack_public_path__ + "static/media/apartment14.257eeb49.jpg";